module.exports = require("./src/signature_pad.ts").default